import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IResourceResource } from "../types";

export interface IResourceQueryParameters {
    resource: RelationalValue<IResourceResource>;
}

export type IResourceQueryResult = IResourceResource;

export const resourceQuery: IApiQueryFunction<IResourceQueryParameters> = ({ resource }) => {
    if (!resource) {
        return;
    }

    return {
        method: "GET",
        url: `/resources/${mapRelationalValue(resource)}`,
    };
};

export const useResourceQuery = createApiQueryHook<IResourceQueryParameters, IResourceQueryResult>(resourceQuery);
